import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";
import { showAlert, showLoading, apiRequest } from "../../../utils";
import { TEAM_COLOR_NAME } from "../../../constants";

import ss from "./ChangeEnergy.module.css";

export const ChangeEnergy = (props) => {
  const session_uuid = useSelector((state) => state.gameSession.session_uuid);
  const { onClose, onConfirm } = props;
  // 调整能量值
  const [teamUUID, setTeamUUID] = useState(""); //名称
  const [changeType, setChangeType] = useState("1"); //加减
  const [energyNum, setEnergyNum] = useState(); //数量
  const [teamList, setTeamList] = useState([]);

  const getTeamList = () => {
    const loading = showLoading("加载中");
    apiRequest("/get_team_list", "GET", { session_uuid })
      .then((res) => {
        if (res.code === 0) {
          setTeamList(res.teams);
          setTeamUUID(res.teams[0]?.uuid || "");
        } else {
          showAlert(res.msg);
        }
      })
      .catch((err) => showAlert("请求失败，请稍后重试", err.message))
      .finally(() => {
        loading.hide();
      });
  };

  // 获取场次信息
  useEffect(() => {
    getTeamList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session_uuid]);

  return (
    <div className={ss.container}>
      <div className={ss.title}>调整能量值</div>
      <div className={ss.cue_box}>
        <div className={ss.energy}>
          <p>队伍</p>
          <select
            className={ss.select}
            onChange={(e) => setTeamUUID(e.target.value)}
          >
            {teamList.map((item, index) => {
              return (
                <option key={item.uuid} value={item.uuid}>
                  {TEAM_COLOR_NAME[item.color]}队
                </option>
              );
            })}
          </select>
        </div>
        <div className={ss.energy}>
          <p>增加/扣除</p>
          <select
            className={ss.select}
            onChange={(e) => setChangeType(e.target.value)}
          >
            <option value="1">增加</option>
            <option value="0">扣除</option>
          </select>
        </div>
        <div className={ss.energy}>
          <p>点数</p>
          <input
            type="number"
            className={ss.num_input}
            value={energyNum}
            maxLength={2}
            onChange={(e) => {
              if (e.target.value && e.target.value < 0) {
                return alert("能量值不能小于0");
              } else {
                setEnergyNum(e.target.value);
              }
            }}
          />
        </div>
      </div>
      <div className={classNames(ss.btn, ss.close)} onClick={onClose}>
        关闭
      </div>
      <div
        className={classNames(ss.btn, ss.confirm, !energyNum && ss.disabled)}
        onClick={() => {
          onConfirm?.({
            teamUUID,
            changeType,
            energyNum,
          });
        }}
      >
        确认
      </div>
    </div>
  );
};
